import { useMemo } from 'react'
import LoadingIndicator from '@/components/LoadingIndicator'
import Divider from '@/components/Divider'
import CountdownBanner from '../CountdownBanner'
import PinProduct from '../PinProduct'
import BagList from '../BagList'
import CouponList from '../CouponList'
import { Coupon } from '@/utils/types'
import styles from './index.module.sass'

interface CouponModule {
  link?: string
  coupons?: Coupon[]
  hasCoupons?: boolean
  onRefresh?: () => void
}

interface Props {
  benefitEndTime?: Date
  isLoading: boolean
  isTosAgreed: boolean
  isShowTosDialog: boolean
  onCouponEmptyClick?: () => void
  bag: any
  coupon: CouponModule
}

const ShoppingBag = ({ benefitEndTime, isLoading, isShowTosDialog, isTosAgreed, onCouponEmptyClick, bag = {}, coupon: { link, coupons, onRefresh, hasCoupons } = {} }: Props) => {
  const bagItems = (bag?.products || []).filter(product => product.display)
  const pinList = bag?.pin

  const pinProduct = useMemo(() => {
    if (!Array.isArray(pinList) || pinList.length <= 0) return null
    const firstId = pinList[0]
    const bagItems = bag?.products || []
    return bagItems.find((product) => product.productId === firstId)
  }, [bag?.products, pinList])

  const showDivider = useMemo(
    () => isLoading || isShowTosDialog || hasCoupons || benefitEndTime,
    [isLoading, isShowTosDialog, hasCoupons, benefitEndTime]
  )

  return (
    <div className={styles.main}>
      <CountdownBanner endTime={benefitEndTime} />
      <CouponList
        isLoading={isLoading || isShowTosDialog}
        isTosAgreed={isTosAgreed}
        link={link}
        coupons={coupons}
        hasCoupons={hasCoupons}
        onRefresh={onRefresh}
        onEmptyClick={onCouponEmptyClick}
      />
      {showDivider && <Divider />}
      {
        isLoading
          ? <div className={styles.loading}>
              <LoadingIndicator />
            </div>
          : <>
              <PinProduct product={pinProduct} />
              <BagList bagItems={bagItems} />
            </>
      }
    </div>
  )
}

export default ShoppingBag
